import React from 'react';
export function ExpertSection() {
  return <section className="w-full bg-bg-dark py-20 px-4" data-id="element-69">
      <div className="max-w-3xl mx-auto text-center" data-id="element-70">
        <div className="text-4xl sm:text-5xl mb-6" data-id="element-71">⚽</div>

        <h2 className="text-3xl sm:text-4xl font-serif font-black text-text-main mb-6" data-id="element-72">
          Qui est Edulabs France ?
        </h2>

        <p className="text-text-sec text-lg sm:text-xl leading-relaxed font-medium max-w-2xl mx-auto" data-id="element-73">
          Nous sommes nés avec une mission : rendre du temps et de la sérénité
          aux enseignants d'EPS. Nous savons à quel point il est épuisant de
          planifier sans structure claire. EPS PRÊT-À-L'EMPLOI est le système
          que nous aurions aimé avoir à nos débuts.
        </p>
      </div>
    </section>;
}